import React from "react";
import { BemHelper } from "@/utils/BemHelper";
import classNames from "classnames";
import { Theme, ThemeFontVariant, ThemeIntent } from "../types";
import CtPublicContainer from "../public-container/CtPublicContainer";
import { THEMES, THEME_FONT_VARIANTS, THEME_INTENTS } from "../constants";
import { useActiveBreakpoints } from "@/utils/useActiveBreakpoints";
import { Row, Col } from "antd";
import CtSectionSeparator from "../section-separator/CtSectionSeparator";

export const SECTION_INTENTS: Record<string, ThemeIntent | "dark" | "light"> = {
  DARK: "dark",
  LIGHT: "light",
  ...THEME_INTENTS,
};

const bem = new BemHelper("ct-faq-section");

export type CtFAQSectionProps = {
  mainImage?: string;
  sectionTitle?: string;
  title?: string;
  children: React.ReactNode;
  disablePaddings?: boolean;
  intent?: ThemeIntent | "dark" | "light";
  theme?: Theme;
  fontVariant?: ThemeFontVariant;
};

function CtFAQSection({
  sectionTitle,
  title,
  children,
  theme,
  intent,
  fontVariant,
  disablePaddings,
}: CtFAQSectionProps) {
  const Container = disablePaddings ? React.Fragment : CtPublicContainer;

  const { activeBreakpoints } = useActiveBreakpoints();

  return (
    <section
      className={classNames(
        bem.block(),
        bem.modifier(theme || THEMES.THEME_1),
        bem.modifier(intent || SECTION_INTENTS.DEFAULT),
        bem.modifier(fontVariant || THEME_FONT_VARIANTS.FONT_VARIANT_1),
        !activeBreakpoints.md && bem.modifier("mobile"),
      )}
    >
      <Container>
        <Row gutter={activeBreakpoints.md ? [60, 60] : [30, 30]}>
          <Col span='24' style={{ paddingTop: activeBreakpoints.md ? 40 : 0 }}>
            {sectionTitle && (
              <CtSectionSeparator label={sectionTitle} intent={intent || THEME_INTENTS.DEFAULT} />
            )}
            {title && (
              <div
                className={classNames(
                  bem.element("title"),
                  !activeBreakpoints.md && bem.modifier("mobile", "title"),
                )}
              >
                {title}
              </div>
            )}

            <div
              className={classNames(
                bem.element("content-container"),
                !activeBreakpoints.md && bem.modifier("mobile", "content-container"),
              )}
            >
              <div className={classNames(bem.element("content"))}>{children}</div>
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

CtFAQSection.defaultProps = {
  title: null,
  intent: THEME_INTENTS.DEFAULT,
  fontVariant: THEME_FONT_VARIANTS.FONT_VARIANT_1,
  subtitle: null,
  disablePaddings: false,
};

export default CtFAQSection;
